module.exports = "data:image/svg+xml,%3Csvg enable-background='new 0 0 100 100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m94.5 0h-89c-3 0-5.5 2.5-5.5 5.5v89c0 3 2.5 5.5 5.5 5.5h47.9v-38.7h-13v-15.1h13v-11.1c0-12.9 7.9-19.9 19.4-19.9 5.5 0 10.3.4 11.6.6v13.5h-8c-6.3 0-7.5 3-7.5 7.3v9.6h14.9l-1.8 15.1h-13v38.7h25.5c3 0 5.5-2.5 5.5-5.5v-89c0-3-2.5-5.5-5.5-5.5z' fill='%23fff'/%3E%3C/svg%3E"


//////////////////
// WEBPACK FOOTER
// ./static/images/facebook-white.svg
// module id = 393
// module chunks = 1